const types = {
    UPDATE_USER: 'UPDATE_USER',
    SET_PIN_USER: 'SET_PIN_USER',
    DELETE_USER: 'DELETE_USER'
  }

 export default types;